import { ContainerModule } from 'inversify';
import { ExamSessionService, ExamSessionServiceSymbol } from './exam-session-service'

export const examSessionServiceModule = new ContainerModule((bind) => {
  bind(ExamSessionServiceSymbol).to(ExamSessionService).inSingletonScope();
});
